import { LegalDocumentLink as SharedLegalDocumentLink } from '@tix-ticketing/ui-components';
import { useState } from 'react';
import type { LegalDocumentKind } from 'lib/hooks/use-legal-document';
import { useLegalDocument } from 'lib/hooks/use-legal-document';
type LegalDocumentLinkProps = {
  document: LegalDocumentKind;
  children: React.ReactNode;
};
export function LegalDocumentLink({
  document,
  children
}: LegalDocumentLinkProps) {
  const [open, setOpen] = useState(false);
  const legalDocument = useLegalDocument(document, open);
  return <SharedLegalDocumentLink open={open} onOpenChange={setOpen} {...legalDocument}>
      {children}
    </SharedLegalDocumentLink>;
}